import { createSlice } from "@reduxjs/toolkit";
import { getCountryList, getCurrencyDDList, getPlatformFees, getQuickPayLinerOptions, getQuickPayModeOptions, validateQuickPayInvoice } from "./actions/quickPayActions";

interface IQuickPayTableData{
    rowNumber: any;
    invoiceId?: number | null;
    invoiceNo: string;
    invoiceAmount?: number | null;
    error: { invoiceNo: boolean, invoiceAmount: boolean},
    remove: boolean,
    invDt: string;
    eximIndicator: string;
    shipmentNumber: string;
    blNo: string;
    valid: boolean;
}

interface IQuickPay{
    data: Array<IQuickPayTableData>,
    countryList:Array<any>,
    pymtModeList:Array<any>,
    currencyList:Array<any>,
    linerList:Array<any>,
    pymtMode:string|null,
    platformFees:string,
    platformChargeConfigId:string|null,
    linerId:string,
    country:string,
    currency: string
}

const initialState:IQuickPay = {
  data: [
    {
      rowNumber: crypto.randomUUID(),
      invoiceId: null,
      invoiceNo: "",
      invoiceAmount: null,
      error: { invoiceNo: false, invoiceAmount: false},
      remove: true,
      invDt: "",
      eximIndicator: "",
      shipmentNumber: "",
      blNo: "",
      valid: false
    },
  ],
  countryList:[],
  pymtModeList:[],
  currencyList:[],
  linerList:[],
  pymtMode:null,
  linerId: '',
  country: '',
  platformFees:'',
  platformChargeConfigId:'',
  currency: '',
};

const quickPaySlice = createSlice({
  initialState,
  name: "quickpay",
  reducers: {
    addQuickPayRow: (state) => {
      state.data.push({
        rowNumber: crypto.randomUUID(),
        invoiceId: null,
        invoiceNo: "",
        invoiceAmount: null,
        error: {
          invoiceNo: false,
          invoiceAmount: false
        },
        remove: true,
        invDt: "",
        eximIndicator: "",
        shipmentNumber: "",
        blNo: "",
        valid: false
      });
    },
    setQuickLiner: (state, action)=>{
      state.linerId = action.payload
    },
    setQuickCountry: (state, action)=>{
      state.country = action.payload
    },
    setQuickCurrency: (state, action)=>{
      state.currency = action.payload
    },
    removeQuickPayRow: (state, action) => {
      if (state.data.length <= 1) {
        state.data = [
          {
            rowNumber: crypto.randomUUID(),
            invoiceId: null,
            invoiceNo: "",
            invoiceAmount: null,
            error: {
              invoiceNo: false,
              invoiceAmount: false,
            },
            remove: true,
            invDt: "",
            eximIndicator: "",
            shipmentNumber: "",
            blNo: "",
            valid: false
          },
        ];
        return;
      }
      state.data = state.data.filter(
        (i) => i.rowNumber !== action.payload.rowNumber
      );
    },
    resetQuickPayTable:(state)=>{
      state.data = [
        {
          rowNumber: crypto.randomUUID(),
          invoiceId: null,
          invoiceNo: "",
          invoiceAmount: null,
          error: {
            invoiceNo: false,
            invoiceAmount: false,
          },
          remove: true,
          invDt: "",
          eximIndicator: "",
          shipmentNumber: "",
          blNo: "",
          valid: false,
        },
      ];
    },
    setQuickPayRow: (state, action) => {
      const row: any = state.data.find(
        (x) => x.rowNumber == action.payload.rowNumber
      );
      row.error = {
        invoiceNo: false,
        invoiceAmount: false,
        invoiceCurrency: false,
      };
      
      row.valid = false
      Object.entries(action.payload).forEach(([key, val]) => {
        row[key] = val;
      });

    },
    quickPayNumberError: (state, action) => {
      action.payload.forEach((i:IQuickPayTableData)=>{
        const x = state.data.find((j)=>j.rowNumber == i.rowNumber)
        if(x)x.error.invoiceNo = true
      })
    },
    setQuickPaymentMode: (state, action)=>{
      state.pymtMode = action.payload
    }
  },
  extraReducers:(builder)=>{
    builder.addCase(getCountryList.fulfilled, (state, action)=>{
        state.countryList = action.payload??[]
    })
    builder.addCase(getQuickPayModeOptions.fulfilled, (state,action)=>{
      state.pymtModeList = action.payload??[]
      state.pymtMode = action.payload?.[0]?.value??null
    })
    builder.addCase(getCurrencyDDList.fulfilled, (state,action)=>{
      state.currencyList = action.payload??[]
      state.currency =  action.payload?.[0]?.currencyCode??''
    })
    builder.addCase(getQuickPayLinerOptions.fulfilled, (state,action)=>{
      state.linerList = action.payload??[]
    })
    builder.addCase(getPlatformFees.fulfilled, (state,action)=>{
      state.platformFees = action.payload.totalPlatformCharge??''
      state.platformChargeConfigId = action.payload?.platformChargeConfigId?`${action.payload?.platformChargeConfigId}`:null
    })
    builder.addCase(validateQuickPayInvoice.fulfilled, (state,action)=>{
      if(!action.payload) return
      const row: any = state.data.find(
        (x) => x.rowNumber == action.payload.rowNumber
      );
      if(action.payload.message){
        row.error = {
          invoiceNo: true,
          invoiceAmount: true,
          invoiceCurrency: true,
        }
        row.valid = false
      }else{
        row.error = {
          invoiceNo: false,
          invoiceAmount: false,
          invoiceCurrency: false,
        }
        row.valid = true
        Object.entries(action.payload).forEach(([key, val]) => {
          if(Object.hasOwn(row,key))row[key] = val;
        });
      }
      
    })
  }
  

});
export const { addQuickPayRow, removeQuickPayRow, setQuickPayRow,
   setQuickPaymentMode, resetQuickPayTable, quickPayNumberError,
    setQuickCountry, setQuickLiner, setQuickCurrency} =
  quickPaySlice.actions;
export default quickPaySlice.reducer;
